import { useSelector } from "react-redux";
import { secondsToHHMMSS, sumOfRecordCounts, sumOfRecordCountsWithoutDecimal } from "../../helper/utility";
import { Constants } from "../Common/Constants";
import AreaGraph from "../Common/Graphs/AreaGraph";
import BarGraph from "../Common/Graphs/BarGraph";
import LineGraph from "../Common/Graphs/LineGraph";

const Yearly = () => {
  // const { userSingle } = useSelector((store) => store.Users);

  const totalWeightsLifted = useSelector((store) => store.userReportReducer.totalWorkoutReport.totalWeightLifted);
  const totalReps = useSelector((store) => store.userReportReducer.totalWorkoutReport.reps);
  const caloriesBurnt = useSelector((store) => store.userReportReducer.totalWorkoutReport.caloriesBurnt);
  const timeUnderTension = useSelector((store) => store.userReportReducer.totalWorkoutReport.timeUnderTension);
  const totalWorkouts = useSelector((store) => store.userReportReducer.totalWorkoutReport.workouts);
  const quickTrainWorkouts = useSelector((store) => store.userReportReducer.userQuickTrainWorkouts);


  const sumOfTotalWeightsLifted = sumOfRecordCounts(totalWeightsLifted);
  const sumOfTotalReps = sumOfRecordCountsWithoutDecimal(totalReps);
  const sumOfTotalCalories = sumOfRecordCounts(caloriesBurnt);
  const sumOfTimeUnderTension = sumOfRecordCounts(timeUnderTension);
  const sumOfTotalWorkouts = sumOfRecordCountsWithoutDecimal(totalWorkouts);
  const sumOfQuickTrainWorkouts = sumOfRecordCountsWithoutDecimal(quickTrainWorkouts);


  return (
    <div className="row mt-4">
      {/* <div id="chart" className="col-md-4">
        <BarGraph
          data={userSingle?.totalWeightByCategoryWithDetails}
          title={Constants.totalWeightLiftedSplit}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <BarGraph
          data={userSingle?.totalRepsByCategoryWithDetails}
          title={Constants.totalRepsSplit}
          format=""
        />
      </div> */}
      {/* <div id="chart" className="col-md-4">
        <BarGraph
          data={userSingle?.strengthAssessment}
          title={Constants.strengthAssessment}
          format=""
        />
      </div> */}
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={userSingle?.totalWeighLifted}
          data={totalWeightsLifted}
          title={`${Constants.totalWeightLifted} ${sumOfTotalWeightsLifted}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={userSingle?.totalReps}
          data={totalReps}
          title={`${Constants.totalReps} ${sumOfTotalReps}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={userSingle?.caloriesBurnt}
          data={caloriesBurnt}
          title={`${Constants.caloriesBurnt} ${sumOfTotalCalories}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <LineGraph
          // data={userSingle?.totalTimeUnderTension}
          data={timeUnderTension}
          title={`${Constants.timeUnderTension} ${secondsToHHMMSS(sumOfTimeUnderTension)}`}
          format=""
          yAxisType={"time"}
        />
      </div>
      {/* <div id="chart" className="col-md-4">
        <LineGraph
          data={userSingle?.progress}
          title={Constants.progress}
          format=""
        />
      </div> */}
      <div id="chart" className="col-md-4">
        <LineGraph
          // data={userSingle?.totalQuickTrainWorkout}
          data={quickTrainWorkouts}
          title={`${Constants.quickTrainWorkout} ${sumOfQuickTrainWorkouts}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <BarGraph
          // data={userSingle?.totalWorkoutCreatedByyearly}
          data={totalWorkouts}
          title={`${Constants.totalWorkouts} ${sumOfTotalWorkouts}`}
          format=""
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Yearly;
